import {
  GlobalContractListResponseSchema,
  GlobalContractSummarySchema,
  GlobalContractWriteResponseSchema,
  type CreateGlobalContractRequest,
  type GlobalContractListResponse,
  type GlobalContractSummary,
  type GlobalContractWriteResponse,
} from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listGlobalContracts(token: string, search = '', afterCode?: string):
  Promise<GlobalContractListResponse> {
  const query = new URLSearchParams({ limit: '100' });
  if (search.trim()) query.set('search', search.trim());
  if (afterCode) query.set('afterCode', afterCode);
  return GlobalContractListResponseSchema.parse(await apiRequest(`/contracts?${query}`, token));
}

export async function getGlobalContract(token: string, contractId: string): Promise<GlobalContractSummary> {
  return GlobalContractSummarySchema.parse(await apiRequest(`/contracts/${encodeURIComponent(contractId)}`, token));
}

export async function createGlobalContract(input: { token: string; idempotencyKey: string;
  draft: CreateGlobalContractRequest }): Promise<GlobalContractWriteResponse> {
  return GlobalContractWriteResponseSchema.parse(await apiRequest('/contracts', input.token, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': input.idempotencyKey },
    body: JSON.stringify(input.draft),
  }));
}

export async function linkContractProject(input: { token: string; contractId: string; projectId: string;
  expectedVersion: number; reason: string; idempotencyKey: string }): Promise<GlobalContractWriteResponse> {
  return GlobalContractWriteResponseSchema.parse(await apiRequest(
    `/contracts/${encodeURIComponent(input.contractId)}/projects`, input.token, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': input.idempotencyKey },
      body: JSON.stringify({ expectedVersion: input.expectedVersion, projectId: input.projectId,
        reason: input.reason }),
    }));
}

export async function unlinkContractProject(input: { token: string; contractId: string; projectId: string;
  expectedVersion: number; reason: string; idempotencyKey: string }): Promise<GlobalContractWriteResponse> {
  return GlobalContractWriteResponseSchema.parse(await apiRequest(
    `/contracts/${encodeURIComponent(input.contractId)}/projects/${encodeURIComponent(input.projectId)}`,
    input.token, { method: 'DELETE', headers: { 'Content-Type': 'application/json',
      'Idempotency-Key': input.idempotencyKey }, body: JSON.stringify({ expectedVersion: input.expectedVersion,
      reason: input.reason }) }));
}
